import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideMenu = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 5h16M4 12h16M4 19h16"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideMenu);
const Memo = memo(ForwardRef);
export default Memo;
